import { FormControlLabel, Switch } from '@mui/material';
import { LightXSmall, TitleXSmall } from '@shared/components/core/text/Typography';
import DeviceTypeModel, { DeviceTypeFieldName } from '@shared/models/devices/DeviceTypeModel';
import OrganizationDeviceTypeModel from '@shared/models/organizations/OrganizationDeviceTypeModel';
import { useTranslation } from 'react-i18next';

export interface IDeviceTypeToggleEditorProps {
    editDeviceType: OrganizationDeviceTypeModel;
    onUpdate: <T extends DeviceTypeFieldName>(fieldName: T, value: DeviceTypeModel[T]) => void;
}

const specificBooleanFields: DeviceTypeFieldName[] = ['canAutoStart', 'isSupported'];

export default function DeviceTypeToggleEditor({ editDeviceType, onUpdate }: IDeviceTypeToggleEditorProps) {
    const { t } = useTranslation();
    return (
        <>
            {specificBooleanFields.map((fieldName) => (
                <FormControlLabel
                    key={fieldName}
                    value="start"
                    control={
                        <Switch
                            checked={!!editDeviceType[fieldName]}
                            onChange={(e) => onUpdate(fieldName, e.target.checked)}
                        />
                    }
                    label={
                        <>
                            <TitleXSmall as="label">
                                {t(`common:organization.projects.deviceType.${fieldName}.title`)}
                            </TitleXSmall>
                            <LightXSmall>
                                {t(`common:organization.projects.deviceType.${fieldName}.description`)}
                            </LightXSmall>
                        </>
                    }
                    labelPlacement="end"
                />
            ))}
        </>
    );
}
